import {Typography} from "@mui/joy";


const PrivacyPolicy = () => {
        return (
            <div className="container">
                    <Typography level={"h1"}>Privacy Policy</Typography>
                    <Typography level={"title-md"}>Effective Date: 05/05/2025</Typography>
                    <Typography level={"body-md"}>
                            At Nualaiochta Consulting, we respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we handle information when you use our app.
                    </Typography>
                    <Typography level={"h3"}>1. Information We Collect</Typography>
                    <Typography level={"body-md"}>
                            We do not collect any personal data from our users. All data is stored on the CDN of the user's server in JSON format that they upload. No data is stored by us.
                    </Typography>
                    <Typography level={"h3"}>2. Third-Party Services</Typography>
                    <Typography level={"body-md"}>
                            We do not use any third-party services that collect personal data, including analytics, advertising, or other tracking technologies.
                    </Typography>
                    <Typography level={"h3"}>3. Cookies and Tracking</Typography>
                    <Typography level={"body-md"}>
                            Our app does not use cookies, local storage, or any other client-side tracking or storage mechanisms.
                    </Typography>
                    <Typography level={"h3"}>4. Data Retention</Typography>
                    <Typography level={"body-md"}>
                            We do not store any data, and all information is uploaded and processed through the user’s own server. The only data exchanged is the JSON provided by the user and the URL where the data is hosted.
                    </Typography>
                    <Typography level={"h3"}>5. Children’s Privacy</Typography>
                    <Typography level={"body-md"}>
                            Our app is intended for a general audience and is not directed toward children under 13.
                    </Typography>
                    <Typography level={"h3"}>6. User Content</Typography>
                    <Typography level={"body-md"}>
                            As a creator of quizzes or polls, you are responsible for the content you create and upload. The content you create is stored solely on your server and is not stored or retained by our app.
                    </Typography>
                    <Typography level={"h3"}>7. Support & Contact</Typography>
                    <Typography level={"body-md"}>
                            When you contact us through JIRA Service Manager, we may collect and store your email address and any other information provided by JIRA. We use this information solely for support purposes and do not use it for marketing or analytics.
                    </Typography>
                    <Typography level={"h3"}>8. Changes to This Privacy Policy</Typography>
                    <Typography level={"body-md"}>
                            We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date.
                    </Typography>
            </div>
        );
}

export default PrivacyPolicy;